import { cn } from "@/lib/utils";

export const EmptyState = ({ icon: Icon, title, description, action, className }) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50/60 px-6 py-12 text-center",
      className
    )}
  >
    {Icon && (
      <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-slate-200/70 text-slate-500">
        <Icon className="h-6 w-6" />
      </div>
    )}
    <h3 className="font-heading text-base font-semibold text-slate-800">{title}</h3>
    {description && <p className="mt-1 max-w-sm text-sm text-slate-500">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);
